<div class="inner-content dark:bg-contrast-black" ridangoAppTrapFocus>
    <div class="flex-column flex h-full text-base dark:bg-contrast-black">
        <div class="relative flex items-center border-b border-solid p-4 dark:border-contrast-yellow">
            <p class="w-full text-center font-semibold">
                {{ 'ENTER' | translate }} {{ 'CART_OTHER_PURPOSE' | translate | lowercase }}
            </p>
            <button
                class="!absolute right-4"
                [attr.aria-label]="'CLOSE_ARIA_LABEL' | translate"
                (click)="cancel()"
                mat-icon-button>
                <mat-icon class="close-button-icon font-bold">close</mat-icon>
            </button>
        </div>
        <div
            class="m-auto mb-1 mt-4 w-10/12 rounded-lg border border-solid bg-grey-white_smoke pl-2 pr-2 pt-2 dark:border-contrast-yellow dark:bg-contrast-black">
            <textarea
                class="w-full resize-none border-0 bg-grey-white_smoke outline-none focus:outline-none dark:bg-contrast-black"
                [(ngModel)]="purposeValue"
                (input)="validatePurposeValue($event)"
                placeholder="{{ 'CART_OTHER_PURPOSE' | translate }}"
                rows="2"
                maxlength="60"></textarea>
        </div>
        <div class="bold ml-8 text-xs text-grey-dark dark:text-contrast-yellow">{{ purposeValue?.length || 0 }}/60</div>

        <div class="m-4">
            <ion-button
                class="ok-button h-14 w-full rounded-lg font-bold dark:bg-contrast-yellow dark:text-contrast-black"
                [disabled]="!purposeValueValidated"
                [attr.aria-label]="'DIALOG_BUTTON_OK' | translate"
                (click)="handleSaveClick()">
                {{ 'DIALOG_BUTTON_OK' | translate }}
            </ion-button>
        </div>
    </div>
</div>
